import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { RedirectRoutes } from "./RedirectRoutes";
import { AppRoutes } from "./AppRoutes";
import { MainLayout } from "@layouts/MainLayout";

export const RoutingHub: FunctionComponent = () => {
  return (
    <Routes>
      <Route path="external-redirects/*" element={<RedirectRoutes />} />
      <Route
        path="/*"
        element={
          <MainLayout>
            <AppRoutes />
          </MainLayout>
        }
      />
    </Routes>
  );
};
